/**
 * This is a Server component. Should only be used in app-router pages
 */

import {
  createAvailabilityLookupTable,
  massageBikeAndSubData,
  BIKE_VARIANTS,
  compareLongBikes
} from "./lib";
import { VariantGrid } from "./variantGrid";
import { createLookupTable } from "/lib";
import { BikeATStore, IBikeStore } from "/lib/bike";
import {
  ISubscriptionStore,
  SubscriptionATStore,
  getUniqueSubscriptionsForBikes
} from "/lib/subscription";

// todo(thusanarul): Fix the types for the sanity input
async function getData({ bikeModels }: { bikeModels: any[] }) {
  const bikeTypeIds: string[] = bikeModels.map((bike) => bike.id);

  const subscriptionStore: ISubscriptionStore = new SubscriptionATStore();
  const bikeStore: IBikeStore = new BikeATStore();

  const bikes = await bikeStore.getBikeModels(bikeTypeIds);
  const subscriptions = await getUniqueSubscriptionsForBikes(subscriptionStore, bikes);

  const bikeModelsTable = createLookupTable(bikeModels, "id");
  const availabilityTable = createAvailabilityLookupTable(bikes);

  const massagedData = massageBikeAndSubData(
    bikes,
    subscriptions,
    bikeModelsTable,
    availabilityTable
  );

  const shortBikes = massagedData.filter((data) => data.variant === "short");
  const longBikes = massagedData.filter((data) => data.variant === "long").sort(compareLongBikes);

  return { short: shortBikes, long: longBikes };
}

export default async function BikeGridList({
  data,
  fokus
}: {
  data: any;
  fokus?: "kort" | "lang";
}) {
  const bikeModels = data.bikeModel as any[];

  const bikes = await getData({ bikeModels });

  const fokusToVariant: Record<string, "short" | "long"> = {
    kort: "short",
    lang: "long"
  };

  const variantEntries = Object.entries(BIKE_VARIANTS);
  const focusedType = fokus ? fokusToVariant[fokus] : undefined;

  const sortedEntries = focusedType
    ? [...variantEntries].sort(([a], [b]) => {
        if (a === focusedType) return -1;
        if (b === focusedType) return 1;
        return 0;
      })
    : variantEntries;

  // [TODO]: Fix so availailiy is not cached in the server component,
  // the other data can be cached or we can request rebuild when bikeTypes are updated in Airtale perhaps

  return (
    <article className="flex flex-col gap-20 h-full w-full">
      {sortedEntries.map(([_, variant], index) => (
        <VariantGrid key={index} variant={variant} bikes={bikes[variant.type]} />
      ))}
    </article>
  );
}
